<template>
  <div class="container" :style="$store.state.equipment.height">
    <input type="file" v-show="false" @change="uploadBankReceipt" ref="fileName1" />
    <div class="overview">
      <div class="item">
        <span class="title">订单编号</span>
        <span class="content">{{orderDetails.orderNo}}</span>
      </div>
      <van-divider :style="{ color: '#1989fa',  padding: '0 ',margin:'0' }" />
      <div class="item">
        <span class="title">批次名称</span>
        <span class="content">{{ orderDetails.appraisalBatchName}}</span>
      </div>
      <!-- <div class="item">
        <span class="title">考试科目</span>
        <span class="content">{{ orderDetails.subjectName }}</span>
      </div> -->
      <div class="item">
        <span class="title">考试工种</span>
        <span class="content">{{ orderDetails.occupation }}</span>
      </div>
      <div class="item">
        <span class="title">考试等级</span>
        <span class="content">{{ orderDetails.skillLevel }}</span>
      </div>
      <template v-if="signupType == 'personal'">
        <div class="item">
          <span class="title">考试时间段</span>
          <span class="content">{{ $moment(orderDetails.examDate).format('YYYY-MM-DD HH:mm:ss') }}</span>
        </div>
        <div class="item">
          <span class="title">考生名称</span>
          <span class="content">{{ orderDetails.payerName }}</span>
        </div>
        <div class="item">
          <span class="title">性别</span>
          <span class="content">{{ orderDetails.sex }}</span>
        </div>
        <div class="item">
          <span class="title">联系方式</span>
          <span class="content">{{ orderDetails.mobile }}</span>
        </div>
      </template>
      <template v-else>
        <div class="item">
          <span class="title">报名人数</span>
          <span class="content">{{ orderDetails.signupNumber }}</span>
        </div>
      </template>
    </div>

    <div class="org-pay" v-if="signupType === 'batch'">
      <div class="title">选择付款方式</div>
      <van-radio-group class="radio" v-model="payType" direction="horizontal">
        <van-radio icon-size="18" name="onlinePay" :disabled="orderDetails.payment >= 50000">线上支付</van-radio>
        <van-radio icon-size="18" name="payByBankCard">银行卡转账</van-radio>
      </van-radio-group>
      <div class="account" v-if="payType === 'payByBankCard'">
        <div class="title">收款信息<span class="remark">*转账备注需写清楚付款用途及付款人数</span></div>
        <div class="details">
          <div>收款单位名称：深圳市健康产业发展促进会</div>
          <div>收款单位账号：769274774613</div>
          <div>开户银行名称：中国银行</div>
          <div>开户行：深圳金地支行</div>
          <div>转账备注：报考订单号{{orderDetails.orderNo}}</div>
        </div>
        <div>
          <div class="title">*请上传支付凭证<span class="files">（上传支付JPG、JPEG、PNG、PDF格式）</span></div>
          <file-box
            @bindup="payfile"
            headert="支付凭证"
            :mainup="payFileUrl"
            :fileName="payFileName"
          ></file-box>
        </div>
      </div>
    </div>

    <div class="button-section">
      <div class="wx-pay">
        <div class="money">
          应付<span class="unit">￥</span>
          <span class="number">{{ (Math.round(orderDetails.payment * 100) / 100).toFixed(2) }}</span>
        </div>
        <button class="wechat-button button" v-if="payType === 'onlinePay'" @click="doWexinPay">支付</button>
        <button class="card-button button" v-else @click="bankCardPay">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import { unipayPay } from '@/utils/wxjssdk'
import fileBox from "@/components/filebox.vue";
import { Dialog } from 'vant';
export default {
  name: 'Order',
  components: {
    fileBox,
  },
  data() {
    return {
      orderDetails: {},
      payType: 'onlinePay',
      status: 0,
      payFileUrl:'',
      payFileName:''
    }
  },
  computed: {
    signupType: function() {
      return this.orderDetails.signupType == '考生交费' ? 'personal' : 'batch'
    }
  },
  created: function() {
    this.fetchOrderDetails();
  },
  methods: {
    fetchOrderDetails: function() {
      const params = {
        orderId: this.$route.query.transOrder,
      }
      this.$http.post('ExamOrder/orderParticulars', params).then(res => {
        if (res.data.success) {
          this.orderDetails = res.data.data.transOrder;
        }
      })
    },
    doWexinPay: function() {
      // this.submitPaySuccess();
      if(!this.$store.state.equipment.isMobile){
        Dialog.alert({
          title: '提示',
          message: 'PC端暂不支持在线支付，现已生成订单，请移步到手机端「我的订单」-「未完成」中，进行支付。'
        })
        return false
      }
      unipayPay(this.$route.query.transOrder, this.submitPaySuccess)
    },
    submitPaySuccess: function() {
      const params = {
        orderId: this.$route.query.transOrder,
        payType: this.payType,
      }
      console.log(this.payType)
      this.$http.post('trans/order/pay', params).then(res => {
          this.$router.replace('/orderpaysuccee')
      })
    },
    payfile() {
      this.status = 1;
      this.$refs.fileName1.click();
    },
    uploadBankReceipt: function(event) {
      var formdata = new FormData();
      formdata.append("file", event.target.files[0]);
      this.$http.post(this.$server.upload, formdata).then(
        (res) => {
          if (res.status == 200) {
            this.payFileUrl = res.data[0].path;
            this.payFileName = res.data[0].fileName;
          }
        }
      );
    },
    bankCardPay: function() {
      if(!this.payFileUrl){
        this.$message({
          message: "请先上传支付凭证",
          type: "warning",
        })
        return false
      }
      const params = {
        orderId: this.$route.query.transOrder,
        payType: 'payByBankCard',
        payVoucher: this.payFileUrl
      }
      this.$http.post('/registration/pay/bankCard', params).then(res => {
        if(res.data.success){
          this.$message({
            message: "提交成功",
            type: "success",
          })
          setTimeout(()=>{
            this.$router.push('/batchSignUp')
          },500)
        }else{
          this.$message({
            message: "error",
            type: "warning",
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  background: #eee;
  height: 100vh;
  position: relative;
  color: #666;
  .overview {
    background: #fff;
    .item {
      padding: 16px;
      .title {
        width: 150px;
        display: inline-block;
        text-align: right;
      }
      .content {
        color: #333;
        padding: 14px;
      }
    }
  }
  .org-pay {
    max-height: 400PX;
    height: 100%;
    overflow-y: auto  ;
    background: #fff;
    margin-top: 18px;
    padding: 24px;
    .title {
      color: #333;
      font-size: 32px;
      padding-top: 12px;
    }
    .radio {
      padding: 12px 0;
    }
    .account {
      font-size: 28px;
      .title {
        font-size: 30px;
        padding-bottom: 12px;
        .remark {
          color: red;
          font-size: 28px;
        }
      }
      .details {
        background: #eee;
        padding: 20px;
        div {
          padding: 6px;
        }
      }
      .files {
        color: #666;
        font-size: 24px;
      }
    }
  }
  .button-section {
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 28px 18px;
    .wx-pay {
      display: flex;
      justify-content: space-between;
      .money {
        .unit {
          color: red;
        }
        .number {
          font-size: 42px;
          color: red;
        }
      }
      .button {
        padding: 12px 48px;
        color: #fff;
        border: none;
        border-radius: 8px;
      }
      .wechat-button {
        background: red;
      }
      .card-button {
        background: #1989fa;
      }
    }
  }
}
</style>






















